import { css } from '@emotion/react';
import { BULK_COLLECTIONS_ARTICLE_LINK, PromoBannerBadge } from '@frontend/high-value-adoption';
import { useTranslation } from '@frontend/i18n';
import { CollectionsPageImage } from '@frontend/payments-assets';
import { Button, Heading, Text } from '@frontend/design-system';

const styles = {
  container: css`
    display: flex;
    justify-content: center;
    background-color: var(--fabric-color-neutral-5);
    padding: var(--fabric-space-padding-lg);
    gap: var(--fabric-space-padding-xl);
    flex-wrap: wrap;
  `,
  featureImage: css`
    border: 1px solid var(--fabric-color-neutral-alpha-100-alpha-10);
    box-shadow: 0px 4px 8px 3px rgba(0, 33, 82, 0.15), 0px 1px 3px 0px rgba(0, 33, 82, 0.3);
    height: auto;
  `,
  paddingMd: css`
    padding: 0 var(--fabric-space-padding-md);
  `,
  content: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--fabric-space-padding-xs);
    max-width: 380px;
  `,
  button: css`
    width: fit-content;
    margin-top: var(--fabric-space-padding-sm);
  `,
};

export const BulkCollectionsFeature = () => {
  const { t } = useTranslation('payments');

  return (
    <div css={styles.container} data-testid='bulk-collections-feature'>
      <div css={styles.paddingMd}>
        <CollectionsPageImage
          css={styles.featureImage}
          width={390}
          borderRadius='var(--fabric-geometry-compact-radius-lg)'
        />
      </div>
      <div css={[styles.paddingMd, styles.content]}>
        <PromoBannerBadge badgeType='new' />
        <Heading level={2}>{t('Collect Faster with Bulk Collections')}</Heading>
        <Text>{t('Nearly 50% of requests sent in bulk are paid same day.')}</Text>
        <Button
          css={styles.button}
          variant='secondary'
          onClick={() => window.open(BULK_COLLECTIONS_ARTICLE_LINK, '_blank', 'noopener,noreferrer')}
        >
          {t('Learn More')}
        </Button>
      </div>
    </div>
  );
};
